<template>
  <div>
    <div class="form-row">
      <div class="form-item form-item-auto">
        <label>{{ $t('form.birthdate.day__' + type) }}</label>
        <input name="day" type="number" min="1" max="31" v-model="day" required v-on:blur="tryEmit()"/>
      </div>
      <div class="form-item form-item-auto">
        <label>{{ $t('form.birthdate.month') }}</label>
        <input name="month" type="number" min="1" max="12" v-model="month" required v-on:blur="tryEmit()"/>
      </div>
      <div class="form-item form-item-auto">
        <label >{{ $t('form.birthdate.year') }}</label>
        <input name="year" type="number" :min="minYear" :max="maxYear" v-model="year" required v-on:blur="tryEmit()"/>
      </div>
      <div v-if="invalid" class="form-item form-item-auto alert alert-error">
        {{ $t('form.birthdate.error_invalid') }}
      </div>
      <div v-else-if="error" class="form-item form-item-auto alert alert-error">
        {{ $t('form.birthdate.error_' + error) }}
      </div>
    </div>
  </div>
</template>

<script>

import { parseISO, isValid, format } from "date-fns";

export default {
  name: 'BirthdateField',
  props: ['value', 'type', 'error', ],
  data() {
    return {
      day: null,
      month: null,
      year: null,
      invalid: false,
    };
  },
  computed: {
    date: {
      get() {
        if (this.day !== null && this.month !== null && this.year !== null) {
          let m =  ""+this.month;
          m = m.replace(/^0*/,'');
          if (this.month < 10) { // oida!
            m = '0'+m;
          }
          let d = ""+this.day;
          d = d.replace(/^0*/,'');
          if (this.day < 10) {
            d = '0'+d;
          }
          return parseISO(this.year+'-'+m+'-'+d);
        }
        return null;
      },
      set(val) {
        if (val) {
          this.day = val.getDate();
          this.month = val.getMonth() + 1;
          this.year = val.getFullYear();
        }
      },
    },
    minYear(){
      const year = new Date().getFullYear()
      return year - (this.type === 'person' ? 80 : 18);
    },
    maxYear(){
      const year = new Date().getFullYear()
      return year - (this.type === 'person' ? 18 : -1);
    },
    showError() {
      return this.error && this.date ? true : false;
    }
  },
  watch: {
    value() {
      if (this.value !== undefined) {
        this.parseDate();
      }
    }
  },
  created() {
    this.parseDate();
  },
  methods: {
    tryEmit(){
      if (this.year && this.month && this.day) {
        if (isValid(this.date)) {
          this.invalid = false;
          this.$emit('input', format(this.date,'yyyy-MM-dd'));
        }
        else {
          this.invalid = true;
          this.$emit('input', undefined);
        }
      }
    },
    parseDate() {
      if (this.value !== null) {
        const date = parseISO(this.value);
        if (date) {
          this.date = date;
        }
      }
    }
  }
}
</script>
